{
  "INBOX_MGMT": {
    "HEADER": "Gelen kutuları",
    "DESCRIPTION": "Kanal, müşterinizin sizinle iletişim kurmak için seçtiği yöntemdir. Gelen kutusu (inbox) ise belirli bir kanal üzerinden gerçekleşen etkileşimleri yönettiğiniz yerdir. Gelen kutusu; e-posta, canlı sohbet ve sosyal medya gibi farklı kaynaklardan gelen iletişimleri içerebilir.",
    "LEARN_MORE": "Gelen kutuları hakkında daha fazla bilgi edinin",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Gelen kutularını ara...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "WhatsApp Business kaydınız tamamlanmadı. Yeniden bağlanmadan önce lütfen Meta Business Manager'da görünen adınızın (display name) durumunu kontrol edin.",
    "COMPLETE_REGISTRATION": "Kaydı Tamamla",
    "LIST": {
      "404": "Bu hesaba bağlı gelen kutusu yok."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Kanal Seçin",
        "BODY": "Chatwoot ile entegre etmek istediğiniz sağlayıcıyı seçin."
      },
      "INBOX": {
        "TITLE": "Gelen Kutusu Oluştur",
        "BODY": "Hesabınızın kimliğini doğrulayın ve bir gelen kutusu oluşturun."
      },
      "AGENT": {
        "TITLE": "Kullanıcı Ekle",
        "BODY": "Temsilcileri oluşturulan gelen kutusuna ekleyin."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Hepiniz gitmeye hazırsınız!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Gelen Kutusu Adı",
        "PLACEHOLDER": "Gelen kutu adınızı girin (örneğin: Acme Inc)",
        "ERROR": "Lütfen geçerli bir gelen kutu adı girin"
      },
      "WEBSITE_NAME": {
        "LABEL": "Web Sitesi Adı",
        "PLACEHOLDER": "Web sitenizin adını girin"
      },
      "FB": {
        "HELP": "Not: Oturum açarak, yalnızca Sayfanızın mesajlarına erişebiliriz. Özel mesajlarınıza Chatwoot ile asla erişilemez.",
        "CHOOSE_PAGE": "Sayfa Seçin",
        "CHOOSE_PLACEHOLDER": "Listeden bir sayfa seçin",
        "INBOX_NAME": "Gelen Kutusu Adı",
        "ADD_NAME": "Gelen kutunuza bir isim ekleyin",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Bir değer seçin",
        "CREATE_INBOX": "Gelen Kutusu Oluştur"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Instagram ile devam et",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Instagram profilinizi bağlayın",
        "HELP": "Instagram profilinizi kanal olarak eklemek için, 'Instagram ile Devam Et' seçeneğine tıklayarak Instagram Profilinizin kimliğini doğrulamanız gerekmektedir. ",
        "ERROR_MESSAGE": "Instagram'a bağlanırken bir hata oluştu, lütfen tekrar deneyin",
        "ERROR_AUTH": "Instagram'a bağlanırken bir hata oluştu, lütfen tekrar deneyin",
        "NEW_INBOX_SUGGESTION": "Bu Instagram hesabı daha önce farklı bir gelen kutusuna bağlıydı ve şimdi buraya taşındı. Tüm yeni mesajlar burada görünecektir. Eski gelen kutusu, bu hesap için artık mesaj gönderemeyecek veya alamayacaktır.",
        "DUPLICATE_INBOX_BANNER": "Bu Instagram hesabı yeni Instagram kanal gelen kutusuna taşındı. Artık bu gelen kutusundan Instagram mesajı gönderip alamayacaksınız.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "Twitter profilinizi bir kanal olarak eklemek için, 'Twitter ile Giriş Yap'ı tıklayarak Twitter Profilinizi doğrulamanız gerekir.",
        "ERROR_MESSAGE": "Twitter'a bağlanırken bir hata oluştu, lütfen daha sonra tekrar deneyin",
        "TWEETS": {
          "ENABLE": "Mentioned Tweets'ten konuşmalar oluştur"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Web Sitesi Kanalı",
        "DESC": "Web siteniz için bir kanal oluşturun ve müşterilerinizi web sitesi widget'ımız aracılığıyla desteklemeye başlayın.",
        "LOADING_MESSAGE": "Web Sitesi Destek Kanalı Oluşturma",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal Avatarı"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Web Kanca URL'si",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Lütfen geçerli bir adres girin"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Web Sitesi Alan Adı",
          "PLACEHOLDER": "Web sitenizin adresini girin"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Hoş Geldiniz Başlığı",
          "PLACEHOLDER": "Merhaba!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Hoş Geldiniz Etiketi",
          "PLACEHOLDER": "Bizimle bağlantı kurmayı kolaylaştırıyoruz. Bize bir şey sorun veya görüşlerinizi paylaşın."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanal Karşılama Mesajı",
          "PLACEHOLDER": "Acme Inc genellikle birkaç saat içinde yanıt verir."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Kanal Karşılamasını Etkinleştir",
          "HELP_TEXT": "Yeni bir konuşma oluşturulduğunda otomatik olarak bir karşılama mesajı gönderin.",
          "ENABLED": "Etkin",
          "DISABLED": "Devre dışı"
        },
        "REPLY_TIME": {
          "TITLE": "Yanıt Zamanını Ayarlayın",
          "IN_A_FEW_MINUTES": "Birkaç dakika içinde",
          "IN_A_FEW_HOURS": "Birkaç saat içinde",
          "IN_A_DAY": "Bir gün içinde",
          "HELP_TEXT": "Bu yanıt süresi, canlı sohbet widget'ında görüntülenecek"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Rengi",
          "PLACEHOLDER": "Widget'ta kullanılacak widget rengini güncelleyin"
        },
        "SUBMIT_BUTTON": "Gelen Kutusu Oluştur",
        "API": {
          "ERROR_MESSAGE": "Web sitesi kanalı oluşturulamadı, lütfen tekrar deneyin"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Kanalı",
        "DESC": "Twilio'yu entegre edin ve müşterilerinizi SMS veya WhatsApp ile desteklemeye başlayın.",
        "ACCOUNT_SID": {
          "LABEL": "Hesap SID'si",
          "PLACEHOLDER": "Lütfen Twilio Hesap SID'nizi girin",
          "ERROR": "Bu alan gereklidir"
        },
        "API_KEY": {
          "USE_API_KEY": "API Anahtar Kimliği Kullan",
          "LABEL": "API Anahtar SID",
          "PLACEHOLDER": "Lütfen API Anahtar SID'nizi girin",
          "ERROR": "Bu alan gereklidir"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Anahtar Sırrı",
          "PLACEHOLDER": "Lütfen API Anahtar Sırrınızı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Mesajlaşma Servisi SID",
          "PLACEHOLDER": "Lütfen Twilio Mesajlaşma Servisi SID'nizi girin",
          "ERROR": "Bu alan gereklidir",
          "USE_MESSAGING_SERVICE": "Twilio Mesajlaşma Servisi Kullan"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanal Türü",
          "ERROR": "Lütfen Kanal Türünüzü seçin"
        },
        "AUTH_TOKEN": {
          "LABEL": "Yetkilendirme Jetonu",
          "PLACEHOLDER": "Lütfen Twilio Yetkilendirme Jetonunuzu girin",
          "ERROR": "Bu alan gereklidir"
        },
        "CHANNEL_NAME": {
          "LABEL": "Gelen Kutusu Adı",
          "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefon Numarası",
          "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
          "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
        },
        "API_CALLBACK": {
          "TITLE": "Geri Ara URL'si",
          "SUBTITLE": "Twilio'daki mesaj geri arama URL'sini burada belirtilen URL ile yapılandırmanız gerekir."
        },
        "SUBMIT_BUTTON": "Twilio Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Twilio kimlik bilgileri doğrulanamadı, lütfen tekrar deneyin"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanalı",
        "DESC": "Müşterilerinizi SMS ile desteklemeye başlayın.",
        "PROVIDERS": {
          "LABEL": "API Sağlayıcı",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bant Genişliği"
        },
        "API": {
          "ERROR_MESSAGE": "SMS kanalı kaydedilemedi"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Hesap Kimliği",
            "PLACEHOLDER": "Lütfen Bandwidth Hesap Kimliğinizi girin",
            "ERROR": "Bu alan gereklidir"
          },
          "API_KEY": {
            "LABEL": "API Anahtarı",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Bu alan gereklidir"
          },
          "API_SECRET": {
            "LABEL": "API Sırrı",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Bu alan gereklidir"
          },
          "APPLICATION_ID": {
            "LABEL": "Uygulama Kimliği",
            "PLACEHOLDER": "Lütfen Bandwidth Uygulama Kimliğinizi girin",
            "ERROR": "Bu alan gereklidir"
          },
          "INBOX_NAME": {
            "LABEL": "Gelen Kutusu Adı",
            "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
            "ERROR": "Bu alan gereklidir"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefon Numarası",
            "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
            "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
          },
          "SUBMIT_BUTTON": "Bandwidth Kanalı Oluştur",
          "API": {
            "ERROR_MESSAGE": "Bandwidth kimlik bilgileri doğrulanamadı, lütfen tekrar deneyin"
          },
          "API_CALLBACK": {
            "TITLE": "Geri Ara URL'si",
            "SUBTITLE": "Bandwidth'taki geri arama URL'sini, burada belirtilen URL ile yapılandırmanız gerekir."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp Kanalı",
        "DESC": "Müşterilerinizi WhatsApp ile desteklemeye başlayın.",
        "PROVIDERS": {
          "LABEL": "API Sağlayıcı",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Bulut",
          "WHATSAPP_CLOUD_DESC": "Meta üzerinden hızlı kurulum",
          "TWILIO_DESC": "Twilio kimlik bilgileriyle bağlanın",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "API sağlayıcınızı seçin",
          "DESCRIPTION": "WhatsApp sağlayıcınızı seçin. Kurulum gerektirmeyen Meta üzerinden doğrudan bağlanabilir veya hesap bilgilerinizi kullanarak Twilio üzerinden bağlanabilirsiniz."
        },
        "INBOX_NAME": {
          "LABEL": "Gelen Kutusu Adı",
          "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefon Numarası",
          "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
          "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası girin."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Telefon Numarası Kimliği",
          "PLACEHOLDER": "Lütfen Facebook geliştirici panelinden elde ettiğiniz Telefon Numarası Kimliği'ni girin.",
          "ERROR": "Lütfen geçerli bir değer girin."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "İş Hesabı Kimliği",
          "PLACEHOLDER": "Lütfen Facebook geliştirici panelinden elde ettiğiniz İş Hesabı Kimliği'ni girin.",
          "ERROR": "Lütfen geçerli bir değer girin."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Onay Anahtarı",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Lütfen geçerli bir değer girin."
        },
        "API_KEY": {
          "LABEL": "API anahtarı",
          "SUBTITLE": "WhatsApp API anahtarını yapılandırın.",
          "PLACEHOLDER": "API anahtarı",
          "ERROR": "Lütfen geçerli bir değer girin."
        },
        "API_CALLBACK": {
          "TITLE": "Geri Arama URL'si",
          "SUBTITLE": "Facebook Developer portalında aşağıda gösterilen değerlerle webhook URL'si ve doğrulama anahtarını yapılandırmanız gerekiyor.",
          "WEBHOOK_URL": "Webhook URL'si",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Onay Anahtarı"
        },
        "SUBMIT_BUTTON": "WhatsApp Kanalı Oluştur",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Meta ile hızlı kurulum",
          "DESC": "Yeni numaraları hızlı bir şekilde bağlamak için WhatsApp Embedded Signup akışını kullanın. WhatsApp Business hesabınıza giriş yapmak için Meta'ya yönlendirileceksiniz. Yönetici erişimi, kurulumu sorunsuz ve kolay hale getirmeye yardımcı olacaktır.",
          "BENEFITS": {
            "TITLE": "Gömülü Kaydın Faydaları:",
            "EASY_SETUP": "Manuel yapılandırma gerekmez",
            "SECURE_AUTH": "Güvenli OAuth tabanlı kimlik doğrulama",
            "AUTO_CONFIG": "Otomatik webhook ve telefon numarası yapılandırması"
          },
          "LEARN_MORE": {
            "TEXT": "Entegre kayıt, fiyatlandırma ve sınırlamalar hakkında daha fazla bilgi için {link} adresini ziyaret edin.",
            "LINK_TEXT": "bu bağlantı"
          },
          "SUBMIT_BUTTON": "WhatsApp Business ile bağlantı kurun",
          "AUTH_PROCESSING": "Meta ile kimlik doğrulama",
          "WAITING_FOR_BUSINESS_INFO": "Lütfen Meta penceresinde işletme kurulumunu tamamlayın...",
          "PROCESSING": "WhatsApp Business Hesabınızı kurma",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Facebook SDK yükleniyor...",
          "CANCELLED": "WhatsApp Kaydı iptal edildi",
          "SUCCESS_TITLE": "WhatsApp Business Hesabı Bağlandı!",
          "WAITING_FOR_AUTH": "Kimlik doğrulaması bekleniyor...",
          "INVALID_BUSINESS_DATA": "Facebook’tan geçersiz işletme verisi alındı. Lütfen tekrar deneyin.",
          "SIGNUP_ERROR": "Kayıt hatası oluştu",
          "AUTH_NOT_COMPLETED": "Kimlik doğrulama tamamlanmadı. Lütfen işlemi yeniden başlatın.",
          "SUCCESS_FALLBACK": "WhatsApp Business Hesabı başarıyla yapılandırıldı",
          "MANUAL_FALLBACK": "Numaranız zaten WhatsApp Business Platformuna (API) bağlıysa veya kendi numaranızı ekleyen bir teknoloji sağlayıcısıysanız, lütfen {link} akışını kullanın",
          "MANUAL_LINK_TEXT": "manuel kurulum akışı",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "WhatsApp kanalını kaydedemedik"
        }
      },
      "VOICE": {
        "TITLE": "Ses Kanalı",
        "DESC": "Twilio Voice’u entegre edin ve müşterilerinize telefon aramalarıyla destek vermeye başlayın.",
        "PHONE_NUMBER": {
          "LABEL": "Telefon Numarası",
          "PLACEHOLDER": "Telefon numaranızı girin (örn. +901234567890)",
          "ERROR": "Lütfen E.164 formatında geçerli bir telefon numarası girin (örn. +901234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Hesap SID'si",
            "PLACEHOLDER": "Twilio Account SID’inizi girin",
            "REQUIRED": "Account SID gereklidir"
          },
          "AUTH_TOKEN": {
            "LABEL": "Yetkilendirme Jetonu",
            "PLACEHOLDER": "Twilio Auth Token’inizi girin",
            "REQUIRED": "Auth Token gereklidir"
          },
          "API_KEY_SID": {
            "LABEL": "API Anahtar SID",
            "PLACEHOLDER": "Twilio API Key SID’inizi girin",
            "REQUIRED": "API Key SID gereklidir"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Anahtar Sırrı",
            "PLACEHOLDER": "Twilio API Key Secret’ınızı girin",
            "REQUIRED": "API Key Secret gereklidir"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Ses URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Bu URL'yi Twilio telefon numaranızda ve TwiML Uygulamanızda Sesli Görüşme URL'si (Voice URL) olarak yapılandırın.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Durum Geri Çağırma URL'si (Status Callback URL)",
          "TWILIO_STATUS_URL_SUBTITLE": "Bu URL'yi Twilio telefon numaranızda Durum Geri Çağırma URL'si (Status Callback URL) olarak yapılandırın."
        },
        "SUBMIT_BUTTON": "Ses Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Ses kanalı oluşturulamadı"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanalı",
        "DESC": "API kanalı ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL'si",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL'si"
        },
        "SUBMIT_BUTTON": "API Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "API kanalını kaydedemedik"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-posta Kanalı",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "EMAIL": {
          "LABEL": "E-Posta",
          "SUBTITLE": "Müşterilerinizin size destek gönderdiği e-posta",
          "PLACEHOLDER": "E-Posta"
        },
        "SUBMIT_BUTTON": "E-posta Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "E-posta kanalını kaydedemedik"
        },
        "FINISH_MESSAGE": "E-postalarınızı aşağıdaki e-posta adresine iletmeye başlayın.",
        "FINISH_MESSAGE_NO_FORWARDING": "E-posta gelen kutunuz başarıyla oluşturuldu! E-posta gönderip almak için SMTP ve IMAP bilgilerinizi yapılandırmanız gerekmektedir. Bu ayarlar yapılmadan hiçbir e-posta işlenmeyecektir.",
        "FORWARDING_ADDRESS_LABEL": "E-postaları bu adrese yönlendirin:",
        "CONFIGURE_SMTP_IMAP_LINK": "Buraya Tıkla",
        "CONFIGURE_SMTP_IMAP_TEXT": " IMAP ve SMTP ayarlarını yapılandırmak için"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Kanalı",
        "DESC": "LINE ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Kanal Kimliği",
          "PLACEHOLDER": "LINE Kanal Kimliği"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanal Sırrı",
          "PLACEHOLDER": "LINE Kanal Sırrı"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanal Token",
          "PLACEHOLDER": "LINE Kanal Token"
        },
        "SUBMIT_BUTTON": "LINE Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "LINE kanalını kaydedemedik"
        },
        "API_CALLBACK": {
          "TITLE": "Geri Arama URL'si",
          "SUBTITLE": "LINE uygulamasında aşağıda belirtilen URL ile webhook URL'sini yapılandırmanız gerekiyor."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanalı",
        "DESC": "Telegram ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Telegram BotFather'dan elde ettiğiniz bot token'ını yapılandırın.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Telegram Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Telegram kanalını kaydedemedik"
        }
      },
      "AUTH": {
        "TITLE": "Bir Kanal Seçin",
        "DESC": "Chatwoot, canlı sohbet widget'ları, Facebook Messenger, Twitter profilleri, WhatsApp, E-postalar vb. olarak kanalları destekler. Özel bir kanal oluşturmak istiyorsanız, API kanalını kullanarak bunu oluşturabilirsiniz. Başlamak için aşağıdaki kanallardan birini seçin.",
        "TITLE_NEXT": "Kurulumu tamamlayın",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Canlı sohbet widget'ı oluşturun"
          },
          "FACEBOOK": {
            "TITLE": "Facebook\n",
            "DESCRIPTION": "Facebook sayfanızı bağlayın"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Müşterilerinize WhatsApp üzerinden destek sağlayın"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-Posta",
            "DESCRIPTION": "Gmail, Outlook veya diğer sağlayıcılarla bağlantı kurun"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "SMS kanalını Twilio veya Bandwidth ile entegre edin"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "API'mizi kullanarak özel bir kanal oluşturun"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Bot token kullanarak Telegram kanalını yapılandırın"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Line kanalınızı entegre edin"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Instagram hesabınızı bağlayın"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Ses",
            "DESCRIPTION": "Twilio Voice ile entegre edin"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Kullanıcılar",
        "DESC": "Yeni oluşturulan gelen kutunuzu yönetmek için burada aracılar ekleyebilirsiniz. Yalnızca bu seçilen temsilciler gelen kutunuza erişebilir. Bu gelen kutusunun parçası olmayan temsilciler, oturum açtıklarında bu gelen kutusundaki mesajları göremeyecek veya yanıtlayamayacak. <br> <b> Not: </b> Bir yönetici olarak, tüm gelen kutularına erişmeniz gerekiyorsa, kendinizi oluşturduğunuz tüm gelen kutularına aracı olarak eklemelisiniz.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Gelen kutusu için aracı seçin"
      },
      "DETAILS": {
        "TITLE": "Gelen Kutusu Ayrıntıları",
        "DESC": "Chatwoot'a bağlanmak istediğiniz Facebook Sayfasını seçmek için aşağıdaki açılır menüden seçim yapın. Daha iyi tanımlama için gelen kutunuza özel bir ad da verebilirsiniz."
      },
      "FINISH": {
        "TITLE": "Başardın!",
        "DESC": "Facebook Sayfanızı Chatwoot ile entegre etmeyi başarıyla tamamladınız. Bir müşteri Sayfanıza bir dahaki sefere mesaj gönderdiğinde, konuşma otomatik olarak gelen kutunuzda görünecektir. <br> Ayrıca, web sitenize kolayca ekleyebileceğiniz bir pencere öğesi komut dosyası da sağlıyoruz. Bu web sitenizde yayınlandıktan sonra, müşteriler herhangi bir harici aracın yardımı olmadan doğrudan web sitenizden size mesaj gönderebilir ve sohbet burada, Chatwoot'ta görünecektir. <br> Harika, ha? Peki, emin olmaya çalışıyoruz :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "E-posta Sağlayıcınızı Seçin",
        "DESCRIPTION": "Aşağıdaki listeden bir e-posta sağlayıcı seçin. Eğer listede e-posta sağlayıcınızı görmüyorsanız, Diğer Sağlayıcı seçeneğini seçebilir ve IMAP ve SMTP Kimlik Bilgilerinizi sağlayabilirsiniz."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft E-posta",
        "DESCRIPTION": "Başlamak için Microsoft ile giriş yapın düğmesine tıklayın. E-posta giriş sayfasına yönlendirileceksiniz. İstenen izinleri kabul ettiğinizde, giriş sayfasına geri yönlendirileceksiniz.",
        "EMAIL_PLACEHOLDER": "E-posta adresini girin",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Microsoft ile bağlantı kurulurken bir hata oluştu, lütfen tekrar deneyin"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "E-posta adresini girin",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Facebook kimliğinizi doğruluyoruz...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Bir şeyler ters gitti, lütfen sayfayı yenileyin...",
      "ERROR_FB_UNAUTHORIZED": "Bu işlemi gerçekleştirmek için yetkiniz yok.",
      "ERROR_FB_UNAUTHORIZED_HELP": "Lütfen Facebook sayfanıza tam kontrolle erişiminiz olduğundan emin olun. Facebook rolleri hakkında daha fazla bilgiyi <a href=\" https://www.facebook.com/help/187316341316631\">buradan</a> okuyabilirsiniz.",
      "CREATING_CHANNEL": "Gelen kutunuz oluşturuluyor...",
      "TITLE": "Gelen Kutusu Ayrıntılarını Yapılandır",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Kullanıcı Ekle",
      "ADD_AGENTS": "Gelen kutunuza aracılar ekleniyor..."
    },
    "FINISH": {
      "TITLE": "Gelen Kutunuz Hazır!",
      "MESSAGE": "Artık yeni kanalınız aracılığıyla müşterilerinizle iletişim kurabilirsiniz. Mutlu destekleme!",
      "BUTTON_TEXT": "Beni oraya götür",
      "MORE_SETTINGS": "Daha fazla ayar",
      "WEBSITE_SUCCESS": "Bir web sitesi kanalı oluşturmayı başarıyla tamamladınız. Aşağıda gösterilen kodu kopyalayın ve web sitenize yapıştırın. Bir müşteri canlı sohbeti bir dahaki sefere kullandığında, konuşma otomatik olarak gelen kutunuzda görünecektir.",
      "WHATSAPP_QR_INSTRUCTION": "WhatsApp gelen kutunuzu hızlıca test etmek için yukarıdaki QR kodu tarayın",
      "MESSENGER_QR_INSTRUCTION": "Facebook Messenger gelen kutunuzu hızlıca test etmek için yukarıdaki QR kodu tarayın",
      "TELEGRAM_QR_INSTRUCTION": "Telegram gelen kutunuzu hızlıca test etmek için yukarıdaki QR kodu tarayın"
    },
    "REAUTH": "Yeniden yetkilendir",
    "VIEW": "Görünüm",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Gelen kutusu ayarları başarıyla güncellendi",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Otomatik atama başarıyla güncellendi",
        "ERROR_MESSAGE": "Gelen kutusu ayarlarını güncelleyemedik. Lütfen daha sonra tekrar deneyin."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Gönderen Adı",
        "SUB_TEXT": "Müşterileriniz, temsilcilerinizden e-posta aldıklarında görecekleri adı seçin.",
        "FOR_EG": "Örneğin:",
        "FRIENDLY": {
          "TITLE": "Dostça",
          "FROM": "dan",
          "SUBTITLE": "Yanıtı gönderen ajanın adını gönderen adına ekleyerek dostça yapın."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesyonel",
          "SUBTITLE": "E-posta başlığında gönderen adı olarak yalnızca yapılandırılmış iş adını kullanın."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "İş adınızı yapılandırın",
          "PLACEHOLDER": "İş adınızı girin",
          "SAVE_BUTTON_TEXT": "Kaydet"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Etkinleştir"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Sil",
      "AVATAR_DELETE_BUTTON_TEXT": "Avatarı Sil",
      "CONFIRM": {
        "TITLE": "Silmeyi Onayla",
        "MESSAGE": "Silmek istediğinize emin misiniz?",
        "PLACE_HOLDER": "{inboxName} yazarak onaylayın",
        "YES": "Evet, Sil ",
        "NO": "Hayır, Tut"
      },
      "API": {
        "SUCCESS_MESSAGE": "Gelen kutusu başarıyla silindi",
        "ERROR_MESSAGE": "Gelen kutusu silinemedi. Lütfen daha sonra tekrar deneyiniz.",
        "AVATAR_SUCCESS_MESSAGE": "Gelen kutusu avatarı başarıyla silindi",
        "AVATAR_ERROR_MESSAGE": "Gelen kutusu avatarı silinemiyor. Lütfen daha sonra tekrar deneyin."
      }
    },
    "TABS": {
      "SETTINGS": "Ayarlar",
      "COLLABORATORS": "Ortak Çalışanlar",
      "CONFIGURATION": "Yapılandırma",
      "CAMPAIGN": "Kampanyalar",
      "PRE_CHAT_FORM": "Sohbet Öncesi Form",
      "BUSINESS_HOURS": "İş Saatleri",
      "WIDGET_BUILDER": "Widget Oluşturucu",
      "BOT_CONFIGURATION": "Bot Yapılandırma",
      "ACCOUNT_HEALTH": "Hesap Sağlığı",
      "CSAT": "CSAT",
      "VOICE": "Ses",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "WhatsApp hesabınızı yönetin",
      "DESCRIPTION": "WhatsApp hesap durumunuzu, mesajlaşma limitlerinizi ve kalitesini inceleyin. Gerekirse ayarları güncelleyin veya sorunları çözün",
      "GO_TO_SETTINGS": "Meta Business Manager'a gidin",
      "NO_DATA": "Sağlık verisi mevcut değil",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Telefon numarasını göster",
          "TOOLTIP": "Müşterilere gösterilen telefon numarası"
        },
        "VERIFIED_NAME": {
          "LABEL": "İşletme adı",
          "TOOLTIP": "WhatsApp tarafından onaylanmış işletme adı"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Görünen adın durumu",
          "TOOLTIP": "İşletme adı doğrulamanızın durumu"
        },
        "QUALITY_RATING": {
          "LABEL": "Kalite puanı",
          "TOOLTIP": "Hesabınız için WhatsApp kalite puanı"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Mesajlaşma limiti seviyesi",
          "TOOLTIP": "Hesabınız için günlük mesajlaşma limiti"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Hesap modu",
          "TOOLTIP": "WhatsApp hesabınızın mevcut çalışma modu"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "24 saatte 250 müşteri",
          "TIER_1000": "24 saatte 1000 müşteri",
          "TIER_1K": "24 saatte 1000 müşteri",
          "TIER_10K": "24 saatte 10000 müşteri",
          "TIER_100K": "24 saatte 100000 müşteri",
          "TIER_UNLIMITED": "24 saatte sınırsız müşteri",
          "UNKNOWN": "Değerlendirme mevcut değil"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "İnceleme Bekliyor",
          "AVAILABLE_WITHOUT_REVIEW": "İnceleme Olmadan Kullanılabilir",
          "REJECTED": "Reddedildi",
          "DECLINED": "Reddedildi",
          "NON_EXISTS": "Mevcut değil"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Canlı"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Ayarlar",
    "FEATURES": {
      "LABEL": "Özellikleri",
      "DISPLAY_FILE_PICKER": "Widget'ta dosya seçiciyi görüntüle",
      "DISPLAY_EMOJI_PICKER": "Widget'ta emoji seçiciyi görüntüleyin",
      "ALLOW_END_CONVERSATION": "Kullanıcılara konuşmayı widget'tan sonlandırma izni ver",
      "USE_INBOX_AVATAR_FOR_BOT": "Bot için gelen kutu adı ve avatarını kullan"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Komut Dosyası",
      "MESSENGER_SUB_HEAD": "Bu düğmeyi gövde etiketinizin içine yerleştirin",
      "ALLOWED_DOMAINS": {
        "TITLE": "İzin Verilen Alan Adları",
        "DESCRIPTION": "Sohbet widget'ınızı hangi web sitelerinin yerleştirebileceğini kısıtlayın. Güvenlik amacıyla, yalnızca sahip olduğunuz ve güvendiğiniz alan adlarını ekleyin. Bir veya daha fazla alan adını virgülle ayırarak ekleyin. Tüm alan adlarına izin vermek için boş bırakın (canlı ortamlar için önerilmez).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Mobil uygulamalarda widget'ı etkinleştir",
        "SUBTITLE": "Widget'ı iOS veya Android uygulamalarına yerleştiriyorsanız bu seçeneği işaretleyin. Mobil uygulamalar alan adı bilgisi göndermediğinden, bu seçenek etkinleştirilmezse alan adı kısıtlamalarına takılarak engellenirler."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Kimlik Doğrulama",
        "DESCRIPTION": "Güvenli token'lar oluşturarak kullanıcıların gerçekliğini doğrulayın. Bu işlem, yetkisiz kişilerin sohbetinizde başkalarının kimliğine bürünmesini engeller.",
        "SECRET_KEY": "Gizli Anahtar",
        "VIEW_DOCS": "Dokümantasyonu görüntüle",
        "REQUIRE_LABEL": "Tüm sohbetler için kimlik doğrulamayı zorunlu kıl",
        "REQUIRE_DESCRIPTION": "Etkinleştirildiğinde, kullanıcıların sohbet başlatabilmesi için geçerli bir kimlik token'ı sunması gerekir. Geçerli bir token içermeyen istekler reddedilecektir."
      },
      "INBOX_AGENTS": "Kullanıcılar",
      "INBOX_AGENTS_SUB_TEXT": "Bu gelen kutusuna aracı ekleyin veya aracıları kaldırın",
      "AGENT_ASSIGNMENT": "Görüşme Atama",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Görüşme atama ayarlarını güncelle",
      "UPDATE": "Güncelleme",
      "ENABLE_EMAIL_COLLECT_BOX": "E-posta toplama kutusunu etkinleştir",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Yeni konuşmalarda e-posta toplama kutusunu etkinleştir veya devre dışı bırak",
      "AUTO_ASSIGNMENT": "Otomatik atamayı etkinleştir",
      "SENDER_NAME_SECTION": "E-postada Ajan Adını Etkinleştir",
      "SENDER_NAME_SECTION_TEXT": "E-postada Ajanın adını göstermeyi/Devre dışı bırakmayı etkinleştirin, devre dışı bırakıldığında iş adını gösterir",
      "ENABLE_CONTINUITY_VIA_EMAIL": "E-posta aracılığıyla konuşma sürekliliğini etkinleştir",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "E-posta adresi mevcut ise konuşmalar e-posta aracılığıyla devam eder.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Gelen Kutusu Ayarları",
      "INBOX_UPDATE_SUB_TEXT": "Gelen kutusu ayarlarınızı güncelleyin",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Bu gelen kutusuna eklenen aracılara yeni konuşmaların otomatik olarak atanmasını etkinleştirin veya devre dışı bırakın.",
      "HMAC_VERIFICATION": "Kullanıcı Kimliği Doğrulama",
      "HMAC_DESCRIPTION": "Bu anahtar ile kullanıcılarınızın kimliğini doğrulamak için kullanılabilecek gizli bir belirteç oluşturabilirsiniz.",
      "HMAC_LINK_TO_DOCS": "Daha fazla bilgi için buraya göz atabilirsiniz.",
      "HMAC_MANDATORY_VERIFICATION": "Zorunlu Kullanıcı Kimliği Doğrulama",
      "HMAC_MANDATORY_DESCRIPTION": "Etkinleştirilmişse doğrulanamayan istekler reddedilecektir.",
      "INBOX_IDENTIFIER": "Gelen Kutusu Tanımlayıcı",
      "INBOX_IDENTIFIER_SUB_TEXT": "API istemcilerinizi kimlik doğrulamak için burada gösterilen `inbox_identifier` belirteci ile kullanın.",
      "FORWARD_EMAIL_TITLE": "E-postaya İlet",
      "FORWARD_EMAIL_SUB_TEXT": "E-postalarınızı aşağıdaki e-posta adresine iletmeye başlayın.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "E-postaların gelen kutunuza yönlendirilmesi bu kurulumda şu anda devre dışı bırakılmıştır. Bu özelliği kullanabilmek için yöneticiniz tarafından etkinleştirilmesi gerekmektedir. Devam etmek için lütfen yönetici ile iletişime geçin.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Çözülen konuşmadan sonra mesajlara izin ver",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Konuşma çözüldükten sonra bile son kullanıcılara mesaj göndermelerine izin ver.",
      "WHATSAPP_SECTION_SUBHEADER": "Bu API Anahtarı, WhatsApp API'larıyla entegrasyon için kullanılır.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "API Anahtarı",
      "WHATSAPP_SECTION_UPDATE_TITLE": "API Anahtarını Güncelle",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Yeni API Anahtarını buraya girin",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Güncelleme",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "Bu gelen kutusu, WhatsApp embedded signup yoluyla bağlandı.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "WhatsApp Business ayarlarınızı güncellemek için bu gelen kutusunu yeniden yapılandırabilirsiniz.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Yeniden yapılandır",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "İş Hesabı Kimliği",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "API Anahtarı",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "WhatsApp Business'a Bağlan",
      "WHATSAPP_CONNECT_SUBHEADER": "Daha kolay yönetim için WhatsApp gömülü kayda (embedded signup) yükseltin.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Gelişmiş özellikler ve daha kolay yönetim için bu gelen kutusunu WhatsApp Business'a bağlayın.",
      "WHATSAPP_CONNECT_BUTTON": "Bağlan",
      "WHATSAPP_CONNECT_SUCCESS": "WhatsApp Business'a başarıyla bağlandı!",
      "WHATSAPP_CONNECT_ERROR": "WhatsApp Business'a bağlanılamadı. Lütfen tekrar deneyin.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "WhatsApp Business başarıyla yeniden yapılandırıldı!",
      "WHATSAPP_RECONFIGURE_ERROR": "WhatsApp Business yeniden yapılandırılamadı. Lütfen tekrar deneyin.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp Uygulama Kimliği yapılandırılmamış. Lütfen yöneticinize başvurun.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Yapılandırma Kimliği yapılandırılmamış. Lütfen yöneticinize başvurun.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp oturum açma işlemi iptal edildi. Lütfen tekrar deneyin.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook Onay Anahtarı",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Bu belirteç, webhook uç noktasının gerçekliğini doğrulamak için kullanılır.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Şablonları Senkronize Et",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "WhatsApp'tan mesaj şablonlarını manuel olarak senkronize ederek mevcut şablonlarınızı güncelleyin.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Şablonları Senkronize Et",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Şablon senkronizasyonu başarıyla başlatıldı. Güncellenmesi birkaç dakika sürebilir.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Kapat",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Telefon numarasını göster",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Ekle",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Gelen Kutusu",
          "PHONE_NUMBER": "Telefon numarası",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Geri",
          "CANCEL": "İptal Et",
          "CONTINUE": "Devam et",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Sohbet Öncesi Form Ayarlarını Güncelleme"
    },
    "HELP_CENTER": {
      "LABEL": "Yardım Merkezi",
      "PLACEHOLDER": "Yardım Merkezi Seçin",
      "SELECT_PLACEHOLDER": "Yardım Merkezi Seçin",
      "NONE": "Hiç",
      "REMOVE": "Yardım Merkezini Kaldır",
      "SUB_TEXT": "Yardım Merkezini gelen kutusuna ekleyin"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Otomatik atama limiti",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Lütfen 0'dan büyük bir değer girin",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Bu gelen kutusundan otomatik olarak bir ajanın atanabileceği maksimum konuşma sayısını sınırlayın"
    },
    "ASSIGNMENT": {
      "TITLE": "Görüşme Atama",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Politikayı sil",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Aktif",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "İptal Et",
      "CONFIRM_DELETE": "Sil",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Yeniden Yetkilendir",
      "SUBTITLE": "Facebook bağlantınızın süresi doldu, hizmetlere devam etmek için lütfen Facebook sayfanızı yeniden bağlayın",
      "MESSAGE_SUCCESS": "Yeniden bağlantı başarılı",
      "MESSAGE_ERROR": "Bir hata oluştu, lütfen tekrar deneyin"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Sohbet öncesi formlar, kullanıcılardan sohbet başlamadan önce bilgi toplamanıza olanak tanır.",
      "SET_FIELDS": "Sohbet Giriş Formu Alanları",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Alanlar",
        "LABEL": "Etiket",
        "PLACE_HOLDER": "Yer Tutucu",
        "KEY": "Anahtar",
        "TYPE": "Tip",
        "REQUIRED": "Zorunlu"
      },
      "ENABLE": {
        "LABEL": "Görüşme öncesi formu etkinleştir",
        "OPTIONS": {
          "ENABLED": "Evet",
          "DISABLED": "Hayır"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Görüşme öncesi mesaj",
        "PLACEHOLDER": "Bu mesaj, kullanıcılara form ile birlikte görünecek"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Ziyaretçilerin sohbeti başlamadan önce ad ve e-posta adresi sağlaması gerekmektedir"
      }
    },
    "CSAT": {
      "TITLE": "CSAT'yi etkinleştir",
      "SUBTITLE": "Müşterilerin destek deneyimleri hakkındaki düşüncelerini anlamak için konuşma sonunda CSAT anketlerini (Müşteri Memnuniyeti Anketleri) otomatik olarak tetikleyin. Memnuniyet eğilimlerini takip edin ve zaman içinde iyileştirme alanlarını belirleyin.",
      "DISPLAY_TYPE": {
        "LABEL": "Görüntüleme türü"
      },
      "MESSAGE": {
        "LABEL": "Mesaj",
        "PLACEHOLDER": "Form ile kullanıcılara göstermek için bir mesaj girin"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Lütfen bizi değerlendirin"
      },
      "LANGUAGE": {
        "LABEL": "Dil",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Mesaj önizlemesi",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "WhatsApp tarafından onaylandı",
        "PENDING": "WhatsApp onayı bekleniyor",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Anket ayrıntılarını düzenle",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Yeni şablon oluştur",
        "CANCEL": "Geri git"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Anket kuralı",
        "DESCRIPTION_PREFIX": "Sohbet olursa anketi gönder",
        "DESCRIPTION_SUFFIX": "etiketlerden herhangi biri",
        "OPERATOR": {
          "CONTAINS": "i̇çerir",
          "DOES_NOT_CONTAINS": "i̇çermez"
        },
        "SELECT_PLACEHOLDER": "etiketleri seç"
      },
      "NOTE": "Not: CSAT anketleri, konuşma başına yalnızca bir kez gönderilir",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT ayarları başarıyla güncellendi",
        "ERROR_MESSAGE": "CSAT ayarları güncellenemedi. Lütfen daha sonra tekrar deneyin."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Uygunluk Durumunuzu Ayarlayın",
      "SUBTITLE": "Canlı sohbet widget'ınızda uygunluk durumunuzu ayarlayın",
      "WEEKLY_TITLE": "Haftalık saatlerinizi ayarlayın",
      "TIMEZONE_LABEL": "Zaman Dilimini Seçin",
      "UPDATE": "İş Saatleri Ayarlarını Güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için iş uygunluğunu etkinleştir",
      "UNAVAILABLE_MESSAGE_LABEL": "Ziyaretçiler için uygun değil mesajı",
      "TOGGLE_HELP": "İşletme erişilebilirliğini etkinleştirmek, tüm temsilciler çevrimdışı olsa bile canlı sohbet ekranında mevcut saatleri gösterecektir. Mevcut saatler dışında ziyaretçiler bir mesaj ve ön sohbet formu ile uyarılabilir.",
      "DAY": {
        "DAY": "Gün",
        "AVAILABILITY": "Uygunluk",
        "HOURS": "Saat",
        "ENABLE": "Bu gün için uygunluğu etkinleştir",
        "UNAVAILABLE": "Uygun Değil",
        "VALIDATION_ERROR": "Başlangıç saati kapanış saatinden önce olmalıdır.",
        "CHOOSE": "Seçin"
      },
      "ALL_DAY": "Tüm Gün"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "IMAP detaylarınızı ayarlayın",
      "NOTE_TEXT": "SMTP'yi etkinleştirmek için lütfen IMAP'ı yapılandırın.",
      "UPDATE": "IMAP ayarlarını güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için IMAP yapılandırmasını etkinleştir",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP ayarları başarıyla güncellendi",
        "ERROR_MESSAGE": "IMAP ayarları güncellenemedi"
      },
      "ADDRESS": {
        "LABEL": "Adres",
        "PLACE_HOLDER": "Adres (Örnek: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Giriş",
        "PLACE_HOLDER": "Giriş"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "ENABLE_SSL": "SSL'yi Etkinleştir",
      "AUTH_MECHANISM": "Kimlik Doğrulama"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "MICROSOFT hesabınızı tekrar yetkilendirin"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "SMTP detaylarınızı ayarlayın",
      "UPDATE": "SMTP ayarlarını güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için SMTP yapılandırmasını etkinleştir",
      "TOGGLE_HELP": "SMTP'yi etkinleştirmek, kullanıcının e-posta göndermesine yardımcı olacaktır",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP ayarları başarıyla güncellendi",
        "ERROR_MESSAGE": "SMTP ayarları güncellenemedi"
      },
      "ADDRESS": {
        "LABEL": "Adres",
        "PLACE_HOLDER": "Adres (Örnek: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Giriş",
        "PLACE_HOLDER": "Giriş"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "DOMAIN": {
        "LABEL": "Alan",
        "PLACE_HOLDER": "Alan"
      },
      "ENCRYPTION": "Şifreleme",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Doğrulama Modu",
      "AUTH_MECHANISM": "Kimlik Doğrulama"
    },
    "NOTE": "Not: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Web Sitesi Avatarı",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar başarıyla silindi",
              "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Web Sitesi Adı",
          "PLACE_HOLDER": "Web sitenizin adını girin",
          "ERROR": "Lütfen geçerli bir web sitesi adı girin"
        },
        "WELCOME_HEADING": {
          "LABEL": "Hoş Geldiniz Başlığı",
          "PLACE_HOLDER": "Merhaba!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Hoş Geldiniz Etiketi",
          "PLACE_HOLDER": "Bizimle bağlantı kurmayı kolaylaştırıyoruz. Bize bir şey sorun veya görüşlerinizi paylaşın."
        },
        "REPLY_TIME": {
          "LABEL": "Yanıt Süresi",
          "IN_A_FEW_MINUTES": "Birkaç dakika içinde",
          "IN_A_FEW_HOURS": "Birkaç saat içinde",
          "IN_A_DAY": "Bir gün içinde"
        },
        "WIDGET_COLOR_LABEL": "Widget Rengi",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Tip:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Sohbet et",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Sohbet et"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Widget Ayarlarını Güncelle",
          "API": {
            "SUCCESS_MESSAGE": "Widget ayarları başarıyla güncellendi",
            "ERROR_MESSAGE": "Widget ayarları güncellenemedi"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Önizleme",
          "SCRIPT": "Komut Dosyası"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Sol",
          "RIGHT": "Sağ"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standart",
          "EXPANDED_BUBBLE": "Genişletilmiş Kabarcık"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Varsayılan",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Genellikle birkaç dakika içinde yanıt verir",
        "IN_A_FEW_HOURS": "Genellikle birkaç saat içinde yanıt verir",
        "IN_A_DAY": "Genellikle bir gün içinde yanıtlar"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Görüşmeyi Başlatın",
        "CHAT_INPUT_PLACEHOLDER": "Mesajınız"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Çevrimiçiyiz",
          "OFFLINE": "Şu an operatörlerimiz müsait değil"
        },
        "USER_MESSAGE": "Merhaba",
        "AGENT_MESSAGE": "Merhaba"
      },
      "BRANDING_TEXT": "Chatwoot tarafından desteklenmektedir",
      "SCRIPT_SETTINGS": "\nwindow.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Microsoft ile giriş yap"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Google ile giriş yap"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Diğer Sağlayıcılar",
        "DESCRIPTION": "Diğer Sağlayıcılar ile giriş yap"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-Posta",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanalı",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Ses"
    }
  }
}
